var exports = {
  "vK": "x31de4314--f69fd2--banner",
  "Qs": "x31de4314--f69fd2--content",
  "Qq": "x31de4314--f69fd2--text",
  "wx": "x31de4314--f69fd2--header",
  "h_": "x31de4314--f69fd2--description",
  "Pf": "x31de4314--f69fd2--label",
  "D4": "x31de4314--f69fd2--house-left",
  "iS": "x31de4314--f69fd2--house-right",
  "w9": "x31de4314--f69fd2--coin",
  "$T": "x31de4314--f69fd2--tablet-coin",
};

module.exports = exports;
